const matchedName = (match)=>{
    var _ref, _ref1, _ref2;
    return (_ref = (_ref1 = (_ref2 = match === null || match === void 0 ? void 0 : match.exact) !== null && _ref2 !== void 0 ? _ref2 : match === null || match === void 0 ? void 0 : match.contains) !== null && _ref1 !== void 0 ? _ref1 : match === null || match === void 0 ? void 0 : match.fuzzy) !== null && _ref !== void 0 ? _ref : match === null || match === void 0 ? void 0 : match.startsWith;
};
const isNameOnly = (bundle)=>bundle.services == null;
const isBareExistence = (bundle)=>{
    var _bundle_or;
    return isNameOnly(bundle) && ((_bundle_or = bundle.or) !== null && _bundle_or !== void 0 ? _bundle_or : []).length === 0 && matchedName(bundle.name) === '';
};
const namedArms = (bundle)=>{
    var _bundle_or;
    if (!isNameOnly(bundle)) return undefined;
    const arms = (_bundle_or = bundle.or) !== null && _bundle_or !== void 0 ? _bundle_or : [];
    if (bundle.name != null) {
        return arms.length === 0 && matchedName(bundle.name) !== '' ? [
            {
                name: bundle.name
            }
        ] : undefined;
    }
    const named = arms.filter((arm)=>matchedName(arm.name) != null);
    return named.length === arms.length ? named : undefined;
};
const asServicePredicate = (arms)=>arms.length === 1 ? {
        name: arms[0].name
    } : {
        or: arms.map((param)=>{
            let { name } = param;
            return {
                name
            };
        })
    };
const foldedServicePredicate = (bundle)=>{
    if (isBareExistence(bundle)) return {
        isBundle: true
    };
    const arms = namedArms(bundle);
    return arms == null || arms.length === 0 ? undefined : asServicePredicate(arms);
};
export const bundleFoldFor = (withFoldedServices)=>(filter)=>{
        const bundles = filter.bundles;
        if ((bundles === null || bundles === void 0 ? void 0 : bundles.any) == null || bundles.all != null || bundles.none != null || filter.services != null) {
            return filter;
        }
        const services = foldedServicePredicate(bundles.any);
        return services == null ? filter : withFoldedServices(filter, services);
    };
